const departSelectList = [
	{value: 'all', label: 'All'},
	{ value: 'admin', label: 'Admin' },
	{ value: 'management', label: 'Management' },
	{ value: 'it', label: 'IT' },
	{ value: 'sales', label: 'Sales' },
	{ value: 'marketing', label: 'Marketing' },
	{ value: 'development', label: 'Development' },
	{ value: 'design', label: 'Design' },
	{ value: 'support', label: 'Support' },
	{ value: 'hr', label: 'HR' },
	{ value: 'finance', label: 'Finance' },
	{ value: 'legal', label: 'Legal' },
	{ value: 'other', label: 'Other' },
];
export default departSelectList;